// removed by extract-text-webpack-plugin
module.exports = {"postContainer":"dashboard_postContainer_3zhX5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/dashboard.css
// module id = 362
// module chunks = 0